import { type FunctionComponent } from 'react';
import { ReactComponent as ExamIconSVG } from '../../assets/icons/mevo/exam/ic_exam.svg';
import IconPattern, { type IconProps } from './_IconPattern';

interface ExamIconProps extends IconProps {
  alternative?: boolean;
}

const BeakerIcon: FunctionComponent<ExamIconProps> = (props) => {
  return <IconPattern component={ExamIconSVG} variantPlaces={0} {...props} />;
};

export default BeakerIcon;
